import React from "react"
import "./modal.css"

export const TrainModal = ({ params }) => (
  <div className="modal-text">
    <div className="form-group">
      <label htmlFor="training_mode">Training mode</label>
      <select
        className="form-control"
        id="training_mode"
        name="training_mode"
        defaultValue="efficientdet_lite1"
      >
        <option value="efficientdet_lite1">efficientdet_lite1</option>
        <option value="efficientdet_lite2">efficientdet_lite2</option>
        <option value="efficientdet_lite3">efficientdet_lite3</option>
      </select>
    </div>
    <p>
      Are you sure you want to launch an IA model training in this folder {params.name} ?
    </p>
  </div>
)

export const DeleteModal = ({ params }) => (
  <div className="modal-text">
    <p>
      {params.type === "folder"
        ? "Are you sure you want to delete this folder and its whole content ?"
        : "Are you sure you want to delete this file ?"}
    </p>
  </div>
)

export const FolderModal = ({ params }) => (
  <div>
    <div className="form-group">
      <label htmlFor="textfield">Name*</label>
      <input
        className="form-control"
        id="textfield"
        name="textfield"
        type="text"
        defaultValue={params.src}
        autoFocus
        required
        pattern="^\w.*.*\w$"
      />
    </div>
    <div className="form-group">
      <label htmlFor="description">Description</label>
      <textarea
        className="form-control fixed-background"
        defaultValue={params.metadata ? params.metadata.description : ""}
        name="description"
        id="description"
        rows={5}
      />
    </div>
  </div>
)
